import { RICOS_NODE_TYPE_TO_DATA_FIELD } from '../../../consts.js';
import { TO_RICOS_DECORATION_TYPE, ENTITY_DECORATION_TO_MUTABILITY } from '../consts.js';
import { convertDecorationToDraftData } from './convertDraftPluginData.js';
import { createEntity } from './create-entity.js';
import 'ricos-schema';
import '../../../utils.js';
import 'lodash';
import '../../nodeUtils.js';
import '../../../ReadonlyNonEmptyArray-0e481d0b.js';
import '../../../string-40bcd6bf.js';
import 'uuid';
import '../../generateRandomId.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const createDecorationEntityData = (decoration, entityKey) => {
  const { type, emojiData } = decoration;
  const data = emojiData || convertDecorationToDraftData(__spreadProps(__spreadValues({}, decoration), {
    type: TO_RICOS_DECORATION_TYPE[type]
  }));
  if (data === void 0) {
    throw Error(`ERROR! Unknown entity type "${type}"!`);
  }
  const mutability = ENTITY_DECORATION_TO_MUTABILITY[type];
  return createEntity(entityKey, { type, mutability, data });
};
const getDynamicStyles = (node) => {
  const { textStyle } = node[RICOS_NODE_TYPE_TO_DATA_FIELD[node.type]] || {};
  const { textAlignment, lineHeight } = textStyle || {};
  const { paddingTop, paddingBottom } = node.style || {};
  return {
    textAlignment,
    lineHeight,
    paddingTop,
    paddingBottom
  };
};
const createTextBlockData = (node) => {
  const { indentation = 0 } = node[RICOS_NODE_TYPE_TO_DATA_FIELD[node.type]] || {};
  const { textAlignment, lineHeight, paddingTop, paddingBottom } = getDynamicStyles(node);
  return JSON.parse(
    JSON.stringify({
      textAlignment: textAlignment !== "AUTO" ? textAlignment == null ? void 0 : textAlignment.toLowerCase() : void 0,
      dynamicStyles: (paddingTop || paddingBottom || lineHeight) && {
        "padding-top": paddingTop,
        "padding-bottom": paddingBottom,
        "line-height": lineHeight
      },
      depth: indentation
    })
  );
};

export { createDecorationEntityData, createTextBlockData };
//# sourceMappingURL=getDraftEntityData.js.map
